<pf-section name="ansprechpartner" [title]="'sendmail.prepare.step.contacts-title' | i18next"
            [subtitle]="'sendmail.prepare.step.contacts-instruction' | i18next">
    <pf-radio-enhanced
            [value]="nachrichtenType"
            (valueChange)="nachrichtenTypeChanged.emit($event)"
            [legend]="'sendmail.prepare.step.contacts-select' | i18next"
            [options]="nachrichtenTypeOptions">
    </pf-radio-enhanced>
</pf-section>
